import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Typography } from '@mui/material';

import { Icon, IconOption, Menu } from '@components/base';
import { ImageType } from '@models/Image';

const ViewModeMap: Record<ImageType, IconOption> = {
  poster: 'cropPortrait',
  square: 'cropSquare',
  wide: 'cropLandscape',
};

type ImageTypeToggleProps = {
  imageType: ImageType;
  setImageType: (imageType: ImageType) => void;
};

const ImageTypeToggle: FC<ImageTypeToggleProps> = ({ imageType, setImageType }) => {
  const { t } = useTranslation();

  return (
    <Menu>
      <Tooltip title={t('imageType', { context: imageType })}>
        <Menu.IconButton size='medium' sx={{ position: 'relative' }}>
          <Icon name={ViewModeMap[imageType]} />
          <Typography display='flex' position='absolute' right='-4px'>
            <Icon fontSize='inherit' name='arrowDropDown' />
          </Typography>
        </Menu.IconButton>
      </Tooltip>

      <Menu.Content>
        {Object.entries(ViewModeMap).map(([vm, icon]) => (
          <Menu.Item
            icon={<Icon fontSize='small' name={icon} />}
            key={vm}
            onClick={() => setImageType(vm as ImageType)}
            selected={imageType === vm}
          >
            {t('imageType', { context: vm })}
          </Menu.Item>
        ))}
      </Menu.Content>
    </Menu>
  );
};

export default ImageTypeToggle;
